// BCF 2.1 parser (§35). Tenký wrapper nad sdíleným, verzně tolerantním parserem.
import { parseBCFArchive } from "./BCFParser.js";
export class BCF21Parser {
  parse(files) { return parseBCFArchive(files, "2.1"); }
}
